import React, { Component } from "react";
import axios from "axios";
import {
  tileLayer,
  map as mapLeaflet,
  geoJSON,
  latLngBounds,
  LatLng,
} from "leaflet";
import vectorTileLayer from "esri-leaflet-vector/src/VectorTileLayer";
// import vector

// import esri
// import { map } from "leaflet";

export default class MapLeaflet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: [0, 0],
      zoom: 10,
      kx: 0,
      ky: 0,
      keterangan: "",
      idObject: "",
      loading: true,
      dataMap: null,
      zoomLevel: 0,
    };
  }
  componentDidMount = async () => {
    var map = mapLeaflet(`mapTest${this.props.sublayer}`).setView([0, 111], 6);
    // const layer = tileLayer("http://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}", {
    //   opacity: 1.0,
    //   attribution: "",
    //   minZoom: 1,
    //   maxZoom: 28,
    //   minNativeZoom: 0,
    //   maxNativeZoom: 22,
    // })
    // layer.addTo(map)
    const vector = vectorTileLayer(
      "https://geoservices.big.go.id/rbi/rest/services/Hosted/Rupabumi_Indonesia/VectorTileServer"
    );
    vector.addTo(map);
    let geojson
    console.log(this.props.sublayer);
    // const geoUrl =
    //   "http://3.140.199.3:8081/geoserver/big/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=big%3Ataswil_kabkot_ln&maxFeatures=50&outputFormat=application%2Fld%2Bjson&CQL_FILTER=object_id=%2732.01-36.02%27";
    // const geoUrl =
    //   "http://3.140.199.3:8081/geoserver/big/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=big%3Ataswil_desa_ar&maxFeatures=50&outputFormat=application%2Fld%2Bjson&CQL_FILTER=kdepum='32.01.36.2006'";
    // const geoUrl =
    //   "http://3.140.199.3:8081/geoserver/big/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=big%3Ataswil_kabkot_ar&maxFeatures=50&outputFormat=application%2Fld%2Bjson&CQL_FILTER=kdpkab='32.01'";
//    if (this.props.sublayer === "toponim_pt") {
    //  console.log('toponimi map');
  //    const geoUrl = `http://3.140.199.3:8081/geoserver/big/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=big%3Atoponim_pt&maxFeatures=50&outputFormat=application%2Fld%2Bjson&CQL_FILTER=object_id='${
//        this.props.id
  //    }'`;
//      await axios
      //  .get(geoUrl)
    //    .then((res) => {
  //        this.setState({ dataMap: res.data });
//        })
        //.catch((err) => {
      //    console.log(err);
    //    });
  //    geojson = geoJSON(this.props.data, {
//        style: {
         // color: "#2a63b5",
          //weight: 5,
        //  opacity: 0.65,
      //  },
    //  });
    //  geojson.addTo(map);
    //} else {
      geojson = geoJSON(this.props.data, {
        style: {
          color: "#2a63b5",
          weight: 5,
          opacity: 0.65,
        },
      });
      geojson.addTo(map);
    //}
    // console.log(this.state.dataMap);

    // let center

    // if (this.state.dataMap.features[0].geometry.coordinates[0][0]) {
    //   center = this.getCenter(
    //     this.state.dataMap.features[0].geometry.coordinates[0][0]
    //   );
    //   console.log(this.state.dataMap.features[0].geometry.coordinates[0][0]);
    // } else if (this.state.dataMap.features[0].geometry.coordinates[0]) {
    //   center = this.getCenter(
    //     this.state.dataMap.features[0].geometry.coordinates[0]
    //   );
    //   console.log(center);
    //   if (center.includes(NaN)) {
    //     center = {
    //       lon: this.state.dataMap.features[0].geometry.coordinates[0],
    //       lat: this.state.dataMap.features[0].geometry.coordinates[1],
    //     };
    //   }
    // }

    // console.log(this.state.dataMap.features[0].geometry.coordinates[0]);
    // console.log(
    //   this.getCenter(this.state.dataMap.features[0].geometry.coordinates[0][0])
    // );
    // const center = this.getCenter(
    //   this.state.dataMap.features[0].geometry.coordinates[0][0]
    // );

    // console.log(this.state.dataMap.features[0].geometry.coordinates[0]);
    // console.log(
    //   this.getCenter(this.state.dataMap.features[0].geometry.coordinates[0])
    // );
    // const center = this.getCenter(
    //   this.state.dataMap.features[0].geometry.coordinates[0]
    // );

    // map.flyTo({ lon: center[0], lat: center[1] }, 8);
    try {
      map.fitBounds(geojson.getBounds());
    } catch {
      map.flyTo(
        {
          lon: this.state.dataMap.features[0].geometry.coordinates[0],
          lat: this.state.dataMap.features[0].geometry.coordinates[1],
        },
        11
      );
    }
    map.setMaxZoom(14);

    // var newBounds = new latLngBounds(center)
    // map.fitBounds(newBounds)

    // map.flyTo(
    //   {
    //     lon: this.state.dataMap.features[0].geometry.coordinates[0],
    //     lat: this.state.dataMap.features[0].geometry.coordinates[1],
    //   },
    //   11
    // );

    // map.flyTo([], 10)
    // map.fitBounds(bounds)
    // Control.Scale.addTo(map)
    // control.scale.addTo(map)
  };

  getCenter = (arr) => {
    var twoTimesSignedArea = 0;
    var cxTimes6SignedArea = 0;
    var cyTimes6SignedArea = 0;

    var length = arr.length;

    var x = function(i) {
      return arr[i % length][0];
    };
    var y = function(i) {
      return arr[i % length][1];
    };

    for (var i = 0; i < arr.length; i++) {
      var twoSA = x(i) * y(i + 1) - x(i + 1) * y(i);
      twoTimesSignedArea += twoSA;
      cxTimes6SignedArea += (x(i) + x(i + 1)) * twoSA;
      cyTimes6SignedArea += (y(i) + y(i + 1)) * twoSA;
    }
    var sixSignedArea = 3 * twoTimesSignedArea;
    return [
      cxTimes6SignedArea / sixSignedArea,
      cyTimes6SignedArea / sixSignedArea,
    ];
  };

  render() {
    return <div id={`mapTest${this.props.sublayer}`} style={{ height: 200 }} />;
  }
}
